/**
 * Skeleton da Agenda — header padrão + barra de controles (abas de
 * médico / visão) + grade da semana com painel lateral do dia.
 */
export default function Loading() {
  return (
    <div className="mx-auto flex max-w-7xl animate-pulse flex-col gap-6">
      {/* PageHeader */}
      <div className="h-[104px] rounded-[20px] bg-slate-200" />

      {/* Controles: abas de médico + navegação de semana */}
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="h-10 w-64 rounded-xl border border-slate-200 bg-white" />
        <div className="h-10 w-48 rounded-xl border border-slate-200 bg-white" />
      </div>

      {/* Grade da semana + painel "Pacientes de hoje" */}
      <div className="grid gap-4 lg:grid-cols-[1fr_280px]">
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="grid grid-cols-7 gap-2">
            {Array.from({ length: 7 }).map((_, i) => (
              <div key={i} className="h-5 rounded bg-slate-200" />
            ))}
          </div>
          <div className="mt-3 grid grid-cols-7 gap-2">
            {Array.from({ length: 21 }).map((_, i) => (
              <div key={i} className="h-24 rounded-lg bg-slate-100" />
            ))}
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4">
          <div className="h-4 w-32 rounded bg-slate-200" />
          <div className="mt-4 flex flex-col gap-2">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-12 rounded-lg bg-slate-100" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
